import qrSvg from "./mail-install-qr.svg?raw";

/** URL PWA Mail (QR d’install mobile). */
export const MAIL_INSTALL_URL = "https://mail.app.aureliasuite.fr/";

/** Data-URL SVG du QR (généré localement, pas d’API tierce). */
export function mailInstallQrDataUrl(): string {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(qrSvg)}`;
}
